import axios from 'axios'


import serverName from "./serverName"

const s= serverName
const prefix = 'api/portal-affairs/frontWeb'; //url前缀



// 下载文件
//参数：obj为后台返回的文件流 name为文件名, suffix是文件格式后缀
export function downloadFile(obj, name, suffix) {
    const url = window.URL.createObjectURL(new Blob([obj]))
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    let fileName
    if (suffix) {
        fileName = name + '.' + suffix
    }
    else {
        fileName = name
    }
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}


//下载文件请求
export function downloadFileRequest(serverName, api, method, data, loading = true, head) {
    const accessToken = sessionStorage.getItem("accessToken")

    //设置头部header
    const headers = {
        // "userAuthType": "MS",
        'accessToken': accessToken
    }
    return new Promise((resolve, reject) => {
        const instance = axios.create({
            baseURL: '',
            timeout: 15000, // 请求超时时间
        })
        instance({
            // url: "/" + serverName + api,
            url: s!='' ? "/" + s + prefix + api : prefix + api,
            headers: head ? head : headers,
            method: method,
            data: data,
            responseType: 'blob'
        }).then(res => {
            if (res.data.code == 200) {
                resolve(res)
            } else {
                reject(res)
            }
            resolve(res) //回调
        })
            .catch(err => {
                reject(err) //回调
            })
    })
}